// IT
export const hotelRoomsManager = {
  header: {
    eyebrow: "Camere d'albergo",
    title: "Gestione delle camere",
    subtitle:
      "Crea i tipi di camera e genera le unità fisiche con la loro numerazione. Queste camere si sincronizzeranno con Channex.",
    addRoom: "Aggiungi camera",
  },
  states: {
    loading: "Caricamento camere...",
    emptyTitle: "Ancora nessuna camera",
    emptySubtitle:
      "Crea il primo tipo di camera per iniziare a configurare tariffe e disponibilità in Channex.",
    addFirstRoom: "Aggiungi la prima camera",
  },
  card: {
    roomsBadge: "{count} camera | {count} camere",
    maxGuests: "Max. {count} ospiti",
    editTitle: "Modifica camera",
    deleteTitle: "Elimina camera",
    adults: "{count} adulto | {count} adulti",
    children: "{count} bambino | {count} bambini",
    infants: "{count} neonato | {count} neonati",
    units: "Unità",
  },
  physical: {
    title: "Camere fisiche",
    subtitle:
      "Modifica il numero o il nome di ogni camera, oppure spostala in un altro tipo. Le sue prenotazioni la seguono. Trascinale dalla maniglia per ordinarle all'interno del loro tipo: è l'ordine che vedrai nel calendario.",
    roomsCount: "{count} camera | {count} camere",
    savingOrder: "Salvataggio ordine…",
    selectAll: "Seleziona tutto",
    clearSelection: "Deseleziona tutto",
    dragToOrder: "Trascina per riordinare",
    selectRoom: "Seleziona {label}",
    roomFallback: "camera",
    codePlaceholder: "N. / codice",
    namePlaceholder: "Nome",
  },
  bar: {
    selectedCount: "camera selezionata | camere selezionate",
    clearSelection: "Deseleziona tutto",
    changeType: "Cambia tipo",
  },
  modal: {
    createTitle: "Nuova camera",
    editTitle: "Modifica camera",
    createSubtitle: "Definisci il tipo e genera le unità fisiche",
    editSubtitle: "Aggiorna i dettagli del tipo di camera",
    basicInfo: "Informazioni di base",
    nameLabel: "Nome della camera",
    namePlaceholder: "Es. Camera doppia, Junior Suite…",
    descriptionLabel: "Descrizione",
    optional: "(facoltativo)",
    descriptionPlaceholder: "Vista mare, terrazza, minibar…",
    inventorySection: "Inventario e capacità",
    countLabel: "Numero di camere",
    countHintZero:
      "Creato senza camere: potrai poi assegnargli camere esistenti dall'elenco delle camere fisiche.",
    countHint: "Unità fisiche totali di questo tipo",
    capacityLabel: "Capacità totale (ospiti)",
    capacityHint: "Massimo consentito tra adulti + bambini + neonati",
    priceLabel: "Prezzo a notte",
    priceHint:
      "Questo crea la sua tariffa standard. Potrai perfezionarla in seguito in “Tariffe hotel”.",
    adultsLabel: "Adulti",
    childrenLabel: "Bambini",
    infantsLabel: "Neonati",
    numberingSection: "Numerazione delle camere",
    toggleOn: "Attivato",
    toggleOff: "Disattivato",
    numberingHintCreate:
      "Le camere vengono create con un codice automatico. Puoi modificarlo una per una nell'elenco delle camere fisiche, oppure impostare la numerazione da “Modifica” così le successive nasceranno già numerate.",
    prefixLabel: "Prefisso del codice",
    prefixPlaceholder: "Es. 10  o  A-",
    prefixHint: 'Es. prefisso "10" + inizio 1 → 101, 102…',
    startNumberLabel: "Numero iniziale",
    paddingLabel: "Riempimento",
    paddingHint: "3 → 001, 002…",
    nameModeLabel: "Nomi delle camere fisiche",
    nameModeType: "Solo tipo",
    nameModeTypeExample: "Doppia",
    nameModeTypeCode: "Tipo + codice",
    nameModeTypeCodeExample: "Doppia 101",
    preview: {
      lead: "Creeremo",
      roomsNoun: "camera | camere",
      withNumbering: "con questa numerazione. Esempio:",
    },
    numberingHintKeep:
      "Le camere esistenti mantengono il loro numero. Questa numerazione si applicherà a quelle che aggiungerai d'ora in poi.",
    numberingHintZero:
      "Senza camere non c'è nulla da numerare. Assegnagli camere esistenti dall'elenco delle camere fisiche.",
    numberingHintDisabled:
      "Le camere fisiche non verranno generate automaticamente. Puoi attivarlo quando vuoi.",
    cancel: "Annulla",
    saving: "Salvataggio…",
    creating: "Creazione…",
    saveChanges: "Salva modifiche",
    createRoom: "Crea camera",
  },
  delete: {
    title: "Elimina camera",
    subtitle: "Questa azione non può essere annullata",
    confirmCopy: "Digita il nome della camera per confermare:",
    placeholder: "Nome della camera",
    cancel: "Annulla",
    deleting: "Eliminazione...",
    confirm: "Elimina",
  },
  change: {
    title: "Cambia il tipo {target}",
    subtitle: "Il numero della camera non cambia",
    newTypeLabel: "Nuovo tipo",
    newTypePlaceholder: "Scegli in quale tipo spostarla…",
    blocksHead: "Una prenotazione sta bloccando il cambio | {count} prenotazioni stanno bloccando il cambio",
    moves: "Si sposta nel nuovo tipo",
    stays: "Rimane nel tipo attuale",
    addMissing: "Aggiungi {labels} al cambio e riprova",
    stockLabel: "Camere in vendita",
    checkingReservations: "Controllo quali prenotazioni si trovano in {target}…",
    thisRoom: "questa camera",
    theseRooms: "queste camere",
    theRoom: "la camera",
    theRooms: "le camere",
    noReservations: "Non ci sono prenotazioni in {target}.",
    reservationsLeave: "prenotazione esce | prenotazioni escono",
    with: "con {target}",
    moreReservations: "e {count} prenotazione in più | e {count} prenotazioni in più",
    greyLegend: "Le camere in grigio rimangono nel tipo attuale.",
    retry: "Riprova",
    cancel: "Annulla",
    applying: "Modifica in corso…",
    confirm: "Sì, cambia tipo",
    titleTargetOne: "della camera {label}",
    titleTargetMany: "di {count} camera | di {count} camere",
    textZero: "Queste camere sono già di quel tipo: scegline un altro per spostarle.",
    textOne:
      "La camera mantiene il suo numero e le sue prenotazioni: cambia solo il tipo con cui viene venduta. Dove si trova ora ci sarà una camera in meno in vendita e, nel nuovo tipo, una in più.",
    textMany:
      "Le {count} camere mantengono il loro numero e le loro prenotazioni: cambia solo il tipo con cui vengono vendute. Dove si trovano ora ci saranno {count} camere in meno in vendita e, nel nuovo tipo, {count} in più.",
  },
  blockTitles: {
    huespedDentro: "Un ospite ha effettuato il check-in",
    reservaRepartida: "La prenotazione occupa altre camere",
    reservaSinAsignar: "Alla prenotazione mancano alcune delle sue camere",
    fallback: "Non può essere spostata",
  },
  groups: {
    noType: "Nessun tipo assegnato",
  },
  reservation: {
    noName: "Senza nome",
  },
  toasts: {
    roomsChanged: "Camera cambiata di tipo | {count} camere cambiate di tipo",
    changedSyncing: "{done} · aggiornamento dei canali",
    created: "Camera creata con successo",
    updated: "Camera aggiornata",
    deleted: "Camera eliminata",
  },
  errors: {
    generic: "Qualcosa è andato storto.",
    loadRooms: "Errore durante il caricamento delle camere",
    updateQty: "Impossibile aggiornare la quantità",
    savePhysicalRoom: "Impossibile salvare la camera",
    saveOrder: "Impossibile salvare l'ordine delle camere.",
    checkReservations: "Impossibile verificare quali prenotazioni si trovano in queste camere.",
    changeType: "Impossibile cambiare il tipo di camera.",
    noProperty: "Impossibile recuperare l'alloggio. Riprova.",
    saveRoom: "Errore durante il salvataggio della camera",
    deleteRoom: "Errore durante l'eliminazione",
  },
};
